<template>
    <header class="relative bg-sky-700 text-gray-200 shadow-xl flex justify-between items-center z-20">
        <div class="header-item" @click="toggleNav()">
            <i class="fas fa-bars"></i>
        </div>
        <div class="header-item">
            <a href="/"><img class="h-7" alt="diafischchen.net" src="../assets/images/net_banner_white_600.png" /></a>
        </div>
    </header>

    <transition name="slide">
        <nav v-if="navActivated" class="fixed z-40 bg-sky-700 top-0 left-0 w-80 max-w-full text-gray-200 h-screen overflow-auto">
            <div class="nav-item" @click="toggleNav()">
                <i class="fas fa-times"></i>
            </div>
            <router-link to="/">
                <div class="nav-item" @click="toggleNav()">
                    Über mich
                </div>
            </router-link>
            <router-link to="/projects">
                <div class="nav-item" @click="toggleNav()">
                    Projekte
                </div>
            </router-link>
            <router-link to="/changelog">
                <div class="nav-item" @click="toggleNav()">
                    Changelog
                </div>
            </router-link>
            <router-link to="/privacy">
                <div class="nav-item" @click="toggleNav()">
                    Datenschutz
                </div>
            </router-link>
        </nav>
    </transition>

    <transition name="fade">
        <div class="nav-background bg-gray-900 bg-opacity-50 fixed top-0 bottom-0 left-0 right-0 z-30" v-if="navActivated" @click="toggleNav()"></div>
    </transition>
</template>

<script>
export default {
    name: 'Navbar',
    data() {
        return {
            navActivated: false
        }
    },
    methods: {
        toggleNav() {
            if (this.navActivated === true) {
                this.navActivated = false;
            } else {
                this.navActivated = true;
            }
        }
    }
}
</script>

<style>

.header-item {
    @apply p-4 text-xl cursor-pointer hover:bg-sky-600 transition-colors;
}

.nav-item {
    @apply py-4 px-5 text-xl cursor-pointer hover:bg-sky-600 transition-colors;
}



.slide-enter-from,
.slide-leave-to {
    @apply transform -translate-x-full;
}

.slide-enter-active,
.slide-leave-active {
    @apply transition-all;
}

.fade-enter-from,
.fade-leave-to {
    @apply opacity-0;
}

.fade-enter-active,
.fade-leave-active {
    @apply transition-all;
}

</style>